import styled from 'styled-components';

import { rem } from '../../utils';

export const StyledVideoWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
`;

export const Video = styled.video<{
  $display: boolean;
  $objectFit?: string;
  $crop?: number;
  $rounded?: boolean;
}>`
  display: ${({ $display }) => ($display ? 'block' : 'none')};
  clip-path: ${({ $crop }) => ($crop ? `inset(${rem($crop)} ${rem($crop)})` : `inset(0)`)};
  object-fit: ${({ $objectFit }) => $objectFit || 'cover'};
  border-radius: ${({ theme, $rounded }) => ($rounded ? rem(theme.Border.Radius.Large) : 0)};
  width: 100%;
  z-index: 0;
`;

export const StyledSkeleton = styled.div<{
  $rounded?: boolean;
}>`
  width: 100%;
  height: 100%;

  .ant-skeleton {
    width: 100% !important;
    height: 100% !important;
  }

  .ant-skeleton-image {
    width: 100% !important;
    border-radius: ${({ theme, $rounded }) =>
      $rounded ? rem(theme.Border.Radius.Large) : 0} !important;
    height: 100% !important;
  }
`;
